module.exports = __webpack_public_path__ + "media/0011.b41c8466.mp3";